import { render, staticRenderFns } from "./_base-loading-icon.vue?vue&type=template&id=f3da206e&lang=pug&"
var script = {}
import style0 from "./_base-loading-icon.vue?vue&type=style&index=0&id=f3da206e&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports